import React from 'react';
import { JournalEntryModel, JOURNAL_ENTRY_SOURCE_TYPES } from '../../../types/bankAccount';
import Avatar from '../misc/Avatar';

interface TransactionProcessorProps {
  entry: JournalEntryModel;
}

export default function TransactionProcessor({ entry }: TransactionProcessorProps) {
  const processedByDashboardMemberId = entry?.processedByDashboardMemberId;
  const processedByDashboardMember = entry?.processedByDashboardMember;
  const sourceType = entry?.sourceType;
  const isInternalTransfer = sourceType === JOURNAL_ENTRY_SOURCE_TYPES.INTERNAL_TRANSFER;
  
  // System-generated transactions that are automatically processed
  const isSystemGenerated = sourceType === JOURNAL_ENTRY_SOURCE_TYPES.CONTRIBUTION_RUN ||
    sourceType === JOURNAL_ENTRY_SOURCE_TYPES.SAVING_POT_FUND ||
    sourceType === JOURNAL_ENTRY_SOURCE_TYPES.SAVING_POT_RELEASE;

  // API contract: null processedByDashboardMemberId or null processedByDashboardMember → show Vera heart
  const showVeraHeart =
    processedByDashboardMemberId == null || processedByDashboardMember == null;

  const veraHeart = (
    <img
      src="/assets/figures/heart.svg"
      alt="Vera"
      className="h-7 w-7"
      title="Ver-AI"
    />
  );

  // Handle internal transfers specially
  if (isInternalTransfer) {
    if (processedByDashboardMember?.user) {
      const { user } = processedByDashboardMember;
      const fullName = `${user.firstName} ${user.lastName}`;
      return (
        <div title={fullName}>
          <Avatar
            src={user.picture ?? undefined}
            alias={fullName}
            className="h-7 w-7"
          />
        </div>
      );
    }
    return veraHeart;
  }

  // System-generated transactions (contributions, saving pots)
  if (isSystemGenerated) {
    return (
      <img
        src="/assets/figures/heart.svg"
        alt="Vera"
        className="h-7 w-7"
        title="System Processed"
      />
    );
  }

  // Only show user avatar when we have both ID and member with user; otherwise Vera heart
  if (!showVeraHeart && processedByDashboardMember?.user) {
    const { user } = processedByDashboardMember;
    const fullName = `${user.firstName} ${user.lastName}`;
    return (
      <div title={fullName}>
        <Avatar
          src={user.picture ?? undefined}
          alias={fullName}
          className="h-7 w-7"
        />
      </div>
    );
  }

  return veraHeart;
}
